import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import OddsFacade from "./Facade/OddsFacade";
import MatchOddsFilters from "./Models/Filters/MatchOddsFilters";
import MatchOddsModel from "./Models/MatchOddsModel";

export default class Odds {
  private readonly facade: OddsFacade;

  constructor(config: SDKConfigurationModel) {
    this.facade = new OddsFacade(config);
  }

  public getByMatchIds = async (
    matchIds: string[],
    filters?: MatchOddsFilters
  ): Promise<Map<string, MatchOddsModel[]>> => {
    return await this.facade.getByMatchIds(matchIds, filters);
  };
}
